import { render, staticRenderFns } from "./DocumentRepository.vue?vue&type=template&id=65402f5e&lang=pug&"
import script from "./DocumentRepository.vue?vue&type=script&lang=js&"
export * from "./DocumentRepository.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports